export default {"src":"https://assets.madeeasy.in/prod/_next/static/media/play-audio.ced7711b.svg","height":44,"width":44,"blurWidth":0,"blurHeight":0};